export default __webpack_public_path__ + "static/media/arrow.65f40b5d.svg";